// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset & base */
body {
  margin: 0;
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-background);
  color: var(--color-text);
}

* {
  box-sizing: border-box;
}

/* App root container */
.main-container {
  min-height: 100vh;
  background-color: var(--color-background);
}

/* Responsive table wrapper: on narrow screens the table scrolls
   horizontally instead of squishing/overlapping its columns. */
.table-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* On small screens force the native <select> to fill (not exceed) its
   container. Fluent's select has flex-grow:1 + min-width:auto, so a long
   option (survey title) made it overflow to the right. */
@media (max-width: 768px) {
  .fui-Select {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }
  .fui-Select__select {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
  }
}

/* Scrollbar styling (subtle) */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-tertiary);
}

/* Selection color */
::selection {
  background-color: var(--undp-primary-light);
  color: var(--undp-primary);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;EACnC,kCAAkC;EAClC,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;+DAC+D;AAC/D;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;yDAEyD;AACzD;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;EAC5B;AACF;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B","sourcesContent":["/* Reset & base */\r\nbody {\r\n  margin: 0;\r\n  font-family: var(--font-family);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: var(--color-background);\r\n  color: var(--color-text);\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* App root container */\r\n.main-container {\r\n  min-height: 100vh;\r\n  background-color: var(--color-background);\r\n}\r\n\r\n/* Responsive table wrapper: on narrow screens the table scrolls\r\n   horizontally instead of squishing/overlapping its columns. */\r\n.table-scroll {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* On small screens force the native <select> to fill (not exceed) its\r\n   container. Fluent's select has flex-grow:1 + min-width:auto, so a long\r\n   option (survey title) made it overflow to the right. */\r\n@media (max-width: 768px) {\r\n  .fui-Select {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-width: 100% !important;\r\n  }\r\n  .fui-Select__select {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-width: 100% !important;\r\n  }\r\n}\r\n\r\n/* Scrollbar styling (subtle) */\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--color-border);\r\n  border-radius: 3px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--color-text-tertiary);\r\n}\r\n\r\n/* Selection color */\r\n::selection {\r\n  background-color: var(--undp-primary-light);\r\n  color: var(--undp-primary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
